class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();

    this.header = document.querySelector('.header-wrapper');
    this.desktopMediaQuery = window.matchMedia('(min-width: 990px)');
    this.hoverMediaQuery = window.matchMedia(
      '(hover: hover) and (pointer: fine)'
    );

    this.closeTimer = null;

    this.addEventListener(
      'mouseenter',
      this.onMouseEnter.bind(this)
    );

    this.addEventListener(
      'mouseleave',
      this.onMouseLeave.bind(this)
    );

    this.addEventListener(
      'focusin',
      this.onHeaderFocusIn.bind(this)
    );

    this.addEventListener(
      'focusout',
      this.onHeaderFocusOut.bind(this)
    );
  }

  supportsDesktopHover() {
    return (
      this.desktopMediaQuery.matches &&
      this.hoverMediaQuery.matches
    );
  }

  onMouseEnter() {
    if (!this.supportsDesktopHover()) return;

    window.clearTimeout(this.closeTimer);
    this.open();
  }

  onMouseLeave() {
    if (!this.supportsDesktopHover()) return;

    window.clearTimeout(this.closeTimer);

    this.closeTimer = window.setTimeout(() => {
      const pointerIsInside = this.matches(':hover');
      const focusIsInside = this.contains(document.activeElement);

      if (!pointerIsInside && !focusIsInside) {
        this.close();
      }
    }, 160);
  }

  onHeaderFocusIn() {
    if (!this.desktopMediaQuery.matches) return;

    window.clearTimeout(this.closeTimer);
    this.open();
  }

  onHeaderFocusOut() {
    window.setTimeout(() => {
      if (!this.contains(document.activeElement)) {
        this.close();
      }
    });
  }

  open() {
    window.clearTimeout(this.closeTimer);

    document.querySelectorAll('header-menu').forEach((menu) => {
      if (menu !== this && typeof menu.close === 'function') {
        menu.close();
      }
    });

    this.mainDetailsToggle.setAttribute('open', '');

    const summary =
      this.mainDetailsToggle.querySelector('summary');

    if (summary) {
      summary.setAttribute('aria-expanded', 'true');
    }

    if (this.header) {
      this.header.preventHide = true;
    }
  }

  close() {
    window.clearTimeout(this.closeTimer);
    super.close();

    if (this.header) {
      this.header.preventHide = false;
    }
  }

  onToggle() {
    if (!this.header) return;

    this.header.preventHide =
      this.mainDetailsToggle.open;

    if (
      document.documentElement.style.getPropertyValue(
        '--header-bottom-position-desktop'
      ) !== ''
    ) {
      return;
    }

    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(
        this.header.getBoundingClientRect().bottom
      )}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
